let view = /*html*/`
<style type="text/css">
    body {
        background-color: transparent !important;
    }
    .mirror {
        transform: scaleX(-1);
    }
    .smooth {
        transition:all 0.25s linear;
    }
    .r_de_dust2
    {
        background-image: url('https://paradoxteam.org/fastdl/de_dust2.png');
    }
    .r_de_inferno
    {
        background-image: url('https://paradoxteam.org/fastdl/de_dust2.png');
    }
    .r_de_nuke
    {
        background-image: url('https://paradoxteam.org/fastdl/de_dust2.png');
    }
    .r_de_train
    {
        background-image: url('https://paradoxteam.org/fastdl/de_dust2.png');
    }
    .flickering
    {
        animation: flick 1.5s infinite;
    }

    @keyframes flick {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
    }

    @keyframes reduceWidth {
    0% {
        width: 100%;
        
    }
    100% {
        width: 0%;
        
    }
    }

    .reduce {
        animation: reduceWidth 35s linear;
    }

    .no-kit 
    {
        animation: reduceWidth 9.5s linear;
    }

    .kit
    {
        animation: reduceWidth 4.5s linear;
    }

    .separator.separator-content::before {
        margin-right: 2px !important;   
    }
    .separator.separator-content::after {
        margin-left: 2px !important;
    }
    

    
</style>
<div class="d-flex flex-column livestream-overlay w-100 px-3 py-3">

    <div class="d-flex flex-row justify-content-between">    
        <!-- <div class="d-flex flex-row position-relative" style="width:25%">
            <div class="position-absolute top-0 left-0 ls-radar-img bgi-position-center bgi-size-cover" map="de_dust2" style="width:386px;height:386px;z-index:-1;background-image: url('https://paradoxteam.org/fastdl/de_dust2.png');"></div>
            <canvas id="ls-canvas" width="386" height="386"></canvas>            
        </div> -->     
        <div class="d-flex position-relative flex-column" style="width:25%">
            <div class="d-flex p-1 align-items-center justify-content-center bg-body" style="width:384px;">
                <div class="fs-5">Playing on <span class="fw-bolder ls-map"></span></div>
            </div>

            <div class="d-flex w-100 align-items-center">
                <div class="ls-radar-img position-relative rounded" map="de_dust2" style="width:384px;height:384px;z-index:-1;background-color: rgba(0,0,0,0.25);">
                    <img class="w-100 h-100 position-absolute left-0 top-0" src="https://paradoxteam.org/fastdl/de_dust2.png" style="z-index:-1"/>
                </div>
            </div>
        </div>
        
        <div class="d-flex flex-column" style="width:45%">
            <div class="d-flex w-100 p-1 align-items-center justify-content-center bg-body">
                <div class="fs-5"><span class="ls-event"></span></div>
            </div>
            <div class="card card-flush py-0 px-0 d-flex flex-row bg-zblack bg-opacity-75 w-100">
                <div class="d-flex align-items-center justify-content-end overflow-hidden" style="width:40%">
                    <div class="d-flex flex-grow-1 align-items-center justify-content-center h-100">
                        <span class="fs-1 ls-team-t-name ">TEAM_A</span>
                        <div class="ls-bomb-planting d-flex flex-column align-items-center justify-content-center bg-danger h-100 w-100 px-4 d-none animate__animated">
                            <span class="fw-bolder text-white fs-3 planting-name text-center text-truncate"></span> 
                            <span class="text-white fs-5 text-center">is planting the bomb</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center fs-3x w-80px h-100" style="background: rgb(253,29,29);background: linear-gradient(90deg, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%);">
                        <span class="ls-team-t-score">0</span>
                    </div>
                </div>
                <div class="d-flex flex-column py-2 bg-body" style="width:20%">
                    <div class="d-flex align-items-center justify-content-center">
                        <span class="fs-5">ROUND <span class="ls-round fw-bold">0/0</span></span>
                    </div>
                    <div class="text-white fs-1 d-flex justify-content-center">
                        <span class="ls-round-timer fw-bolder">0:00</span>
                    </div>
                </div>
                <div class="d-flex align-items-center justify-content-end flex-row-reverse" style="width:40%">
                    <div class="d-flex flex-grow-1 align-items-center justify-content-center h-100">
                        <span class="fs-1 ls-team-ct-name ">TEAM_B</span>
                        <div class="ls-bomb-defusing d-flex flex-column align-items-center justify-content-center bg-info h-100 w-100 px-4 d-none animate__animated">
                            <span class="fw-bolder text-white fs-3 defusing-name text-center text-truncate"></span> 
                            <span class="text-white fs-5 text-center">is defusing the bomb</span>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-center fs-3x w-80px h-100 mirror" style="background: rgb(111,30,255);background: linear-gradient(90deg, rgba(111,30,255,1) 50%, rgba(0,123,255,1) 100%);">
                        <span class="ls-team-ct-score mirror">0</span>
                    </div>
                </div>
            </div>
            <div class="card card-flush py-0 px-0 d-flex flex-row bg-transparent w-100">
                <div class="d-flex align-items-center" style="width:40%">                    
                    <div class="d-flex align-items-center rounded-start ls-bomb-timer d-none animate__animated w-100">
                        <div class="progress h-25px w-100 mirror">
                            <div class="progress-bar bg-danger" role="progressbar" style="width:100%"></div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column" style="width:20%">                    
                    <div class="text-black fs-4 d-flex justify-content-center py-2 bg-success bg-opacity-75 ls-state-container">
                        <span class="ls-match-state fw-bold"></span>
                    </div>
                    <div class="d-flex flex-column align-items-center justify-content-center py-2 bg-zblack bg-opacity-75 d-none ls-bomb-planted">
                        <span class="text-white flickering"><img src="assets/media/weapons/c4red.png" style=""/></span>
                        <span class="text-white fs-3">Planted <span class="ls-site-planted fw-bold"></span></span>
                    </div>
                    <div class="d-flex flex-column align-items-center justify-content-center py-2 bg-zblack bg-opacity-75 d-none ls-bomb-defused">
                        <span class="text-white opacity-25"><img src="assets/media/weapons/C4-6 GO).png" style=""/></span>
                        <span class="text-white fs-3">Bomb Defused!</span>
                    </div>
                </div>
                <div class="d-flex align-items-center" style="width:40%">
                    <div class="d-flex align-items-center rounded-start ls-defuser-timer d-none animate__animated w-100">
                        <div class="progress h-25px w-100">
                            <div class="progress-bar bg-info" role="progressbar" style="width:100%"></div>
                        </div>
                    </div>
                </div>                
            </div>
            <div class="card card-flush py-0 px-0 d-flex flex-row bg-transparent w-100 mt-6 ls-round-winner d-none animate__animated">
                <div class="d-flex align-items-center justify-content-center fs-3 w-100">
                    <div class="ls-round-winner-name px-4 text-black rounded-start fs-2hx fw-boldest h-100 d-flex align-items-center"></div>
                    <div class="bg-black bg-opacity-75 d-flex-align-items-center justify-content-center rounded-end px-4 fw-bold text-center py-2">WINS<br>the Round</div>
                </div>
            </div>
            <div class="card card-flush py-0 px-0 d-flex flex-row bg-transparent w-100 mt-6 ls-round-history d-none animate__animated justify-content-center">
                <div class="d-flex flex-column align-items-center w-125 rounded bg-black bg-opacity-75 py-2 px-2">
                    <div class="d-table w-100">
                        <div class="d-table-row ls-round-history-a w-100">                        
                        </div>
                        <div class="d-table-row ls-round-history-number w-100">
                        </div>
                        <div class="d-table-row ls-round-history-b w-100">
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="d-flex flex-column" style="width:25%">
            <div class="d-flex flex-column align-self-end">
                <div class="d-flex p-1 align-items-center justify-content-center bg-body">
                    <div class="fs-5">Players Alive</div>
                </div>
                <div class="d-flex flex-row justify-content-center w-100 bg-zblack bg-opacity-75 align-items-center ls-players-alive">
                    <span class="text-danger fs-2hx ls-t-players text-center min-w-60px">0</span>
                    <span class="text-white fs-1">vs</span>
                    <span class="text-info fs-2hx ls-ct-players text-center min-w-60px">0</span>
                </div>                                
            </div>
            <div class="d-flex w-100 align-items-end flex-column ls-kf mt-8">
                
            </div>
        </div>
    </div>

    


    <!--<div class="d-flex w-100">
        <div class="d-flex col-3">        
            <div class="px-2 py-1 px-2 py-1 bg-zblack bg-opacity-75">
                <span class="text-gray-700">Now Playing: <span class="text-white ls-map"></span></span>
            </div>
        </div>
        <div class="d-flex col-6">
        </div>
        <div class="d-flex col-3">
        </div>
    </div>-->


    <div class="d-flex flex-row justify-content-between" style="margin-top: 165px;">
    
        <div class="d-flex flex-row" style="width:35%">
            
            <div class="d-flex flex-column ls-team-t rounded overflow-hidden" style="width:57.14%">
                <div class="card card-flush my-0 mx-0 h-80px mb-2" style="background-color: rgba(31,31,31,0.85);">
                    <div class="d-flex align-items-center justify-content-center w-100">
                        <div class="h-80px">
                            <!--<img src="assets/media/logos/ass.png" style="max-width: 100%;height: 100%;"/>-->
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-column rounded overflow-hidden ps-2" style="width:42.86%">
                <div class="card card-flush my-0 mx-0 h-80px mb-2 bg-transparent">
                </div>
                <div class="ls-pscore-t rounded overflow-hidden animate__animated animate__fade animate__fadeOutLeft">
                </div>
            </div>

        </div>

        <div class="d-flex ls-firstperson align-items-end" style="width:28%;height: 480px;">

        </div>

        <div class="d-flex flex-row" style="width:35%">

            <div class="d-flex flex-column rounded overflow-hidden pe-2" style="width:42.86%">
                <div class="card card-flush my-0 mx-0 h-80px mb-2 bg-transparent">                    
                </div>
                <div class="ls-pscore-ct rounded overflow-hidden animate__animated animate__fade animate__fadeOutRight">
                </div>
            </div>

            <div class="d-flex flex-column ls-team-ct rounded overflow-hidden" style="width:57.14%">
                <div class="card card-flush my-0 mx-0 h-80px mb-2" style="background-color: rgba(31,31,31,0.85);">
                    <div class="d-flex align-items-center justify-content-center w-100">
                        <div class="h-80px pub-a" style="display:none">
                            <!--<video autoplay loop muted style="max-width: 100%;height: 100%;">
                                <source src="assets/media/videos/powered.mp4" type="video/mp4">
                            </video>-->
                        </div>
                        <div class="h-80px pub-b">
                            <!--<div class="d-flex h-100 flex-column justify-content-center mx-3">
                                <div><span class="text-white fs-3">Casters:</span> <span class="text-gray-800 fs-3">Fffranchesca Vegettowow.- Eli Groove84</span></div>
                                <div><span class="text-white fs-3">Broadcaster:</span> <span class="text-gray-800 fs-3">GunGameR</span></div>
                            </div>-->
                        </div>
                        <div class="h-80px pub-c">
                            <div class="d-flex h-100 flex-column justify-content-center mx-3">
                                <img class="img-adv" src="assets/media/logos/pdxplay_render_3.png"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>`;

export default view;